import React, { useEffect, useRef, useState } from 'react'
import classes from './BookingForm.module.css'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import { Badge, Box, CircularProgress, Grid, Snackbar, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import MuiAlert from '@mui/material/Alert'
import axios from 'axios'
import { DOMAIN, api } from '../../../utils/api'
import { useCallback } from 'react'
import PageNotFound from '../../404/PageNotFound'
import { mainGreen, mainRed } from '../../../utils/color'

const Alert = React.forwardRef(function Alert(props, ref) {
	return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
})

export default function BookingForm() {
	const productList = [
		{
			id: 0,
			name: 'Gia đình nhỏ 0.5kg',
			brand: 'QUẾ QUÂN',
			price: 240000,
			imageURL: '/img/nem_0.5.jpg',
			quantity: 0,
			weight: 0.5,
			info: 'P 0.5kg',
		},
		{
			id: 1,
			name: 'Hợp lý 700g',
			brand: 'QUẾ QUÂN',
			price: 350000,
			imageURL: '/img/nem_0.7.jpg',
			quantity: 0,
			weight: 0.7,
			info: 'P 0.7kg',
		},
		{
			id: 2,
			name: 'Sum họp 1kg',
			brand: 'QUẾ QUÂN',
			price: 450000,
			imageURL: '/img/nem_1.jpg',
			quantity: 0,
			weight: 1,
			info: 'P 1kg',
		},
		{
			id: 3,
			name: 'Chè dừa dầm',
			price: 25000,
			imageURL: '/img/che_dua_dam.jpg',
			quantity: 0,
			weight: 0,
			info: ' chè dừa dầm',
		},
		{
			id: 4,
			name: 'Chè dừa dầm cafe',
			price: 25000,
			imageURL: '/img/che_cafe.jpg',
			quantity: 0,
			weight: 0,
			info: ' chè dừa dầm cafe',
		},
	]
	const { storeId } = useParams()
	const [message, setMessage] = useState('')
	const [error, setError] = useState(false)
	const [disabledButton, setDisabledButton] = useState(false)
	const [phone, setPhone] = useState('')
	const [address, setAddress] = useState('')
	const [payment, setPayment] = useState('transfer')
	const [cartQuantity, setCartQuantity] = useState(0)
	const [bill, setBill] = useState(0)
	const [product, setProduct] = useState(productList)
	const [state, setState] = React.useState({
		open: false,
		vertical: 'top',
		horizontal: 'right',
	})

	const { vertical, horizontal, open } = state

	const [loading, setLoading] = useState(true)
	const [customers, setCustomers] = useState([])
	const [store, setStore] = useState()

	const getCustomer = useCallback(async function () {
		try {
			const response = await axios({
				url: api.GET_CUSTOMERS_DATA,
				method: 'GET',
			})
			setCustomers(response.data)
		} catch (error) {
			console.log(error)
		}
	}, [])

	useEffect(() => {
		getCustomer()
	}, [getCustomer])

	const getStore = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/customer/store/${storeId}`,
					method: 'GET',
				})
				setStore(response.data)
				setLoading(false)
			} catch (error) {
				console.log(error)
			}
		},
		[storeId],
	)

	useEffect(() => {
		getStore()
	}, [getStore])

	const nameRef = useRef()
	const noteRef = useRef()

	const handleCheckPayment = (e) => {
		const { value, checked } = e.target
		if (checked) {
			setPayment(value)
		}
	}

	const handleChangePhone = (e) => {
		setPhone(e.target.value)
	}

	const handleChangeAddress = (e) => {
		setAddress(e.target.value)
	}

	useEffect(() => {
		const index = customers?.findIndex((customer) => customer?.phone === +phone)
		if (index !== -1) {
			setAddress(customers[index].address)
		}
	}, [phone, customers])

	const handleOpen = () => {
		setState({ ...state, open: true })
	}

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return
		}
		setState({ ...state, open: false })
	}

	const handleIncrease = (id) => {
		const findProduct = product.find((prod) => prod.id === +id)
		if (findProduct) {
			findProduct.quantity += 1
		}
		const updatedProductList = [...product]
		updatedProductList[id] = findProduct
		setProduct((prod) => (prod = updatedProductList))
	}

	const handleDecrease = (id) => {
		const findProduct = product.find((prod) => prod.id === +id)
		if (findProduct && findProduct.quantity > 0) {
			findProduct.quantity -= 1
		}
		const updatedProductList = [...product]
		updatedProductList[id] = findProduct
		setProduct((prod) => (prod = updatedProductList))
	}

	const clearForm = async () => {
		nameRef.current.value = ''
		setPhone('')
		noteRef.current.value = ''
		setAddress('')
		setProduct(productList)
		setPayment('transfer')
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		const checkQuantity = product.find((prod) => prod.quantity > 0)

		if (!checkQuantity) {
			alert('Chưa chọn sản phẩm.')
			return
		}
		const quantity = product.reduce((sum, prod) => (sum += prod.weight * prod.quantity), 0)
		let productInfo = ''
		product.forEach((prod) => {
			if (prod.quantity > 0) {
				productInfo += `${prod.quantity}${prod.info}, `
			}
		})
		const orderData = {
			productInfo,
			name: nameRef.current.value,
			quantity,
			address,
			phone,
			note: noteRef.current.value,
			payment,
			bill,
		}
		if (orderData.name.trim() === '' || address.trim() === '' || phone.trim() === '') {
			alert('Trường có dấu * không được để trống.')
			return
		}

		try {
			setDisabledButton(true)
			const response = await axios({
				method: 'POST',
				url: api.POST_ORDER_BY_SLUG,
				data: { storeId, orderData },
			})
			setMessage(response.data)
		} catch (error) {
			if (error.response.status === 400) {
				setError(true)
				setMessage(error.response.data)
			}
			console.log(error)
		}
		handleOpen()
		setDisabledButton(false)
		await clearForm()
	}

	useEffect(() => {
		const updatedBill = product.reduce((sum, prod) => (sum += prod.quantity * prod.price), 0)
		setBill((prev) => (prev = updatedBill))
		const updatedCartQuantity = product.filter((prod) => prod.quantity > 0).length
		setCartQuantity((prev) => (prev = updatedCartQuantity))
	}, [product])

	if (loading) {
		return (
			<Box sx={{ textAlign: 'center', paddingTop: '120px' }}>
				<div>
					<img loading='lazy' src='/img/logo_quequan.webp' alt='logo' />
				</div>

				<Typography display='flex' justifyContent='center' alignItems='center' sx={{ marginTop: '20px' }}>
					<CircularProgress size='1.5rem' sx={{ marginRight: '10px', color: mainGreen }} />{' '}
					<span>Đang đến trang đặt hàng...</span>
				</Typography>
			</Box>
		)
	}

	if (!loading && store) {
		return (
			<Box>
				<Snackbar anchorOrigin={{ vertical, horizontal }} open={open} autoHideDuration={3000} onClose={handleClose}>
					<Alert onClose={handleClose} severity={error ? 'error' : 'success'} sx={{ width: '100%' }}>
						{message}
					</Alert>
				</Snackbar>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						maxWidth: '1100px',
						margin: '0 auto',
					}}>
					<div className={classes.subtitle}>
						<div>
							<a href='https://quequan.top/' rel='noreferrer' target='_blank'>
								<img loading='lazy' src='/img/logo_quequan.webp' alt='logo' />{' '}
							</a>
						</div>
						<span style={{ paddingRight: '10px', color: '#333333' }}>{store.name?.toUpperCase()}</span>
					</div>
					<Grid container spacing={1} sx={{ padding: '0 5px' }}>
						{product.map((prod, index) => {
							return (
								<Grid sx={{ pt: 0 }} key={index} item xs={4} md={3} lg={12 / 5} display='flex' justifyContent='center'>
									<div className={classes.product}>
										<div>
											<img loading='lazy' src={prod.imageURL} alt='nem' />
											{prod.brand && <p className={classes.brand}>{prod.brand}</p>}
											<p className={classes.product_type}>{prod.name}</p>
										</div>
										<div>
											<div>
												<p className={classes.product_price}>{prod.price?.toLocaleString()}đ</p>
												<div className={classes.action_boxqty}>
													<div className={classes.proloop_boxqty}>
														<button
															type='button'
															className={`${classes.btnqty} ${classes.proloop_minus}`}
															aria-label='Minus'
															onClick={() => handleDecrease(index)}>
															<svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
																{' '}
																<rect height='1' width='18' y='9' x='1'></rect>
															</svg>
														</button>
														<input
															readOnly
															type='number'
															name='quantity-proloop'
															value={prod.quantity}
															className={classes.proloop_qtyvalue}
														/>
														<button
															type='button'
															className={`${classes.btnqty} ${classes.proloop_plus}`}
															aria-label='Plus'
															onClick={() => handleIncrease(index)}>
															<svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
																{' '}
																<rect x='9' y='1' width='1' height='17'></rect>{' '}
																<rect x='1' y='9' width='17' height='1'></rect>
															</svg>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</Grid>
							)
						})}
					</Grid>
					<Grid container spacing={3} sx={{ padding: '60px 12px 20px' }}>
						<Grid item xs={12} md={6}>
							<div className={classes.form}>
								<div className={`${classes.input_container}`}>
									<label htmlFor='name' className={classes.label}>
										<span style={{ color: '#dc2f55' }}>*</span> HỌ TÊN
									</label>
									<input id='name' className={classes.input} type='text' placeholder='Nguyễn Văn A' ref={nameRef} />
								</div>
								<div className={`${classes.input_container} ${classes.ic2}`}>
									<label htmlFor='phone' className={classes.label}>
										<span style={{ color: '#dc2f55' }}>*</span> SỐ ĐIỆN THOẠI
									</label>
									<input
										id='phone'
										className={classes.input}
										type='number'
										placeholder='09xxxxxxxx'
										value={phone}
										onChange={handleChangePhone}
									/>
								</div>
								<div className={`${classes.input_container} ${classes.ic2}`}>
									<label htmlFor='address' className={classes.label}>
										<span style={{ color: '#dc2f55' }}>*</span> THỜI GIAN VÀ ĐỊA CHỈ GIAO HÀNG
									</label>
									<input
										id='address'
										className={classes.input}
										type='text'
										placeholder='17h, Số 100, đường A, phường B, Tân Bình'
										value={address}
										onChange={handleChangeAddress}
									/>
								</div>
								<div className={`${classes.input_container} ${classes.ic2}`}>
									<label htmlFor='note' className={classes.label}>
										GHI CHÚ
									</label>
									<input id='note' className={classes.input} type='text' placeholder='Yêu cầu thêm' ref={noteRef} />
								</div>
								<div className={classes.bill}>
									<Badge
										badgeContent={cartQuantity}
										showZero={true}
										sx={{
											mr: 2,
											'& .MuiBadge-badge': {
												color: '#fff',
												backgroundColor: mainRed,
											},
										}}>
										<ShoppingCartOutlinedIcon sx={{ color: '#333333' }} />
									</Badge>
									<h4 style={{ color: '#333333' }}>
										Hóa đơn: {bill.toLocaleString()}đ{' '}
										<span
											style={{
												fontWeight: 500,
												fontStyle: 'italic',
												color: mainRed,
											}}>
											(Chưa bao gồm phí giao hàng)
										</span>
									</h4>
								</div>
							</div>
						</Grid>
						<Grid
							display='flex'
							flexDirection='column'
							alignItems='center'
							item
							xs={12}
							md={6}
							sx={{ paddingBottom: '20px' }}>
							<div className={classes.bank_info}>
								<div style={{ padding: '0 12px' }}>
									<label className={classes.checkbox_label}>
										<input
											name='value-radio'
											id='cash'
											className={classes.radio_input}
											type='radio'
											value='cash'
											onChange={handleCheckPayment}
										/>
										<div className={classes.radio_design}></div>
										<div className={classes.label_text}>
											<img loading='lazy' style={{ width: '28px', marginRight: '5px' }} src='/img/COD.png' alt='cod' />
											Thanh toán khi giao hàng (COD)
										</div>
									</label>
									<div style={{ borderTop: '1px solid #b8b6b6' }}></div>
									<label className={classes.checkbox_label}>
										<input
											name='value-radio'
											id='transfer'
											className={classes.radio_input}
											type='radio'
											checked={payment === 'transfer'}
											value='transfer'
											onChange={handleCheckPayment}
										/>
										<div className={classes.radio_design}></div>
										<div className={classes.label_text}>
											<img
												loading='lazy'
												style={{ width: '23px', marginRight: '10px' }}
												src='/img/bank_transfer.png'
												alt='cod'
											/>
											Chuyển khoản qua ngân hàng
										</div>
									</label>
									{store.display_transfer_info && (
										<div>
											<p
												style={{
													letterSpacing: '1px',
													margin: 0,
													paddingTop: '5px',
													color: '#333333',
												}}>
												<b>{store.bank?.toUpperCase()}</b>
											</p>
											<p style={{ marginBottom: 0, marginTop: '5px' }}>
												Chủ tài khoản:{' '}
												{store.account_name && <span style={{ fontWeight: '600' }}>{store.account_name}</span>}
											</p>
											<p style={{ marginTop: '5px' }}>
												Số tài khoản:{' '}
												{store.account_number && <span style={{ fontWeight: '600' }}>{store.account_number}</span>}
											</p>
											<p style={{ marginBottom: '5px' }}>Nội dung chuyển khoản, ghi 1 trong 3:</p>
											<ul
												style={{
													paddingLeft: '19px',
													marginTop: 0,
													marginBottom: '16px',
												}}>
												<li>Mã số đơn hàng hoặc</li>
												<li>Điện thoại đặt hàng hoặc</li>
												<li>Địa chỉ nhận hàng</li>
											</ul>
											<p
												style={{
													textAlign: 'center',
													fontStyle: 'italic',
													paddingBottom: '12px',
													margin: 0,
												}}>
												Quý khách gửi bill chuyển tiền cho quán qua Zalo{' '}
												{store.phone && <span style={{ fontWeight: '600' }}>{store.phone}</span>} hoặc Facebook
												Messenger hoặc thông báo qua điện thoại. Xin cảm ơn!
											</p>
										</div>
									)}
								</div>
							</div>
							<button
								disabled={disabledButton}
								type='text'
								className={disabledButton ? classes.submit_progress : classes.submit}
								onClick={(e) => {
									handleSubmit(e)
								}}>
								{disabledButton ? 'Đang xử lý...' : 'Đặt hàng'}
							</button>
						</Grid>
					</Grid>
				</div>
			</Box>
		)
	}

	if (!loading && !store) {
		return <PageNotFound />
	}
}
